import React from 'react';

import { SenderAnalysisProps } from './SenderAnalysis.props';
import './SenderAnalysis.styles.css'
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import {Typography} from "@mui/material";
import Divider from "@mui/material/Divider";
import {useTheme} from "@mui/material/styles";
import {AnalysisRiskBox} from "../AnalysisRiskBox/AnalysisRiskBox";
import { styled } from '@mui/system';
export const SenderAnalysis: React.FC<SenderAnalysisProps>= ({
    payload = {}
}) => {
  const theme = useTheme();
    const Item = styled(Grid)(({ theme }) => ({
        padding: theme.spacing(2),
        flexBasis: '30%',
        flexGrow: 1,
        '@media (max-width: 600px)': {
            flexBasis: '95%',
        },
    }));
  return <Box sx={{py:4, px: 5}} className={'app-box-shadow-md'}>
      <Grid container columnSpacing={{ xs: 3, sm: 2, md: 5 }} >
          <Item item >
              <Box sx={{mb: 2}} className={'app-flex-horizontal flex-space-between'}>
                  <Typography noWrap  variant={'h6'} className={'app-default-header'}>
                      Sender information
                  </Typography>
                  {/*<LaunchIcon fontSize={"medium"} htmlColor={"#193051"}/>*/}
              </Box>
              <Divider sx={{background: theme.palette.ocean_blue.main, mb: 1, borderWidth: 1}} />
              <AnalysisRiskBox payload={{label: 'Sender Display Name', value: payload.name.value || 'N/A', priority: payload.name.priority}} />
              <Divider sx={{background: '#CCCFCF'}} />
              <AnalysisRiskBox payload={{ ...payload.email, label: 'Sender Email Address', value: payload.email.value || 'N/A' }} />
              <Divider sx={{background: '#CCCFCF'}} />
              <AnalysisRiskBox payload={{ ...payload.domain, label: 'Sender Domain', value: payload.domain.value || 'N/A' }} />
          </Item>
          <Grid container display={{ xs: "none", sm: "none", md: "block" }} sx={{width: '1px', borderRadius: "4px", position: 'relative', left: "46px", marginRight: '60px', backgroundColor: '#CCCFCF'}}></Grid>
          <Item item >
              <Box sx={{mb: 2}} className={'app-flex-horizontal flex-space-between'}>
                  <Typography noWrap  variant={'h6'} className={'app-default-header'}>
                      IP information
                  </Typography>
                  {/*<LaunchIcon fontSize={"medium"} htmlColor={"#193051"}/>*/}
              </Box>
              <Divider sx={{background: theme.palette.ocean_blue.main, mb: 1, borderWidth: 1}} />
              <AnalysisRiskBox payload={{ ...payload.ipv4, label: payload.ipv4.value ? ['IPv4', 'IP Location'] : 'IPv4', value: payload.ipv4.value ? [payload.ipv4.value, payload.ipv4?.meta?.country_name || 'N/A'] : 'N/A' }} />
              <Divider sx={{background: '#CCCFCF'}} />
              <AnalysisRiskBox payload={{ ...payload.ipv6, label: payload.ipv6.value ? ['IPv6', 'IP Location'] : 'IPv6', value: payload.ipv6.value ? [payload.ipv6.value, payload.ipv6?.meta?.country_name || 'N/A'] : 'N/A' }} />
          </Item>
          <Grid container display={{ xs: "none", sm: "none", md: "block" }} sx={{width: '1px', borderRadius: "4px", position: 'relative', left: "46px", marginRight: '60px', backgroundColor: '#CCCFCF'}}></Grid>
          <Item item >
              <Box sx={{mb: 2}} className={'app-flex-horizontal flex-space-between'}>
                  <Typography noWrap  variant={'h6'} className={'app-default-header'}>
                      Email Authentication Results
                  </Typography>
                  {/*<LaunchIcon fontSize={"medium"} htmlColor={"#193051"}/>*/}
              </Box>
              { Object.keys(payload).map((key:string) => {
                  if(['dmarc','spf','dkim','arc'].includes(key)){
                      return(
                        <>
                            <Divider sx={key === 'dmarc' ? {background: theme.palette.ocean_blue.main, mb: 1, borderWidth: 1} : {background: '#CCCFCF'}} />
                            <AnalysisRiskBox payload={{
                                label: payload[key].hint, value: payload[key].content, priority: payload[key].result === 'pass' ? "pass":"high", key:'emailAuthen' }} />
                        </>
                      )
                  }
              })}
          </Item>
          <Grid container display={{ xs: "none", sm: "none", md: "block" }} sx={{width: '1px', borderRadius: "4px", position: 'relative', left: "46px", marginRight: '60px'}}></Grid>
      </Grid>
  </Box>
};
